import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Button } from '@/components/Button/Button'
import { CORPORATE_UPLOAD_PATH } from '@/constants/corporateRoutePaths'
import { PERSONAL_SIGNUP_URL } from '@/constants/paytrieAppUrls'
import { useCorporateEnrollment } from '@/hooks/useCorporateEnrollment'
import { useCurrentUser } from '@/hooks/useCurrentUser'
import { CorporateSupportLine } from './CorporateSupportLine'
import { RegistrationVerifiedPage } from './RegistrationVerifiedPage'

export const RegistrationCompletePage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { data: enrollment } = useCorporateEnrollment(true)
  const { data: currentUser } = useCurrentUser(true)

  if (enrollment?.status === 'verified') {
    return (
      <RegistrationVerifiedPage businessEmail={enrollment.corporationEmail} />
    )
  }

  const canRegisterPersonally = enrollment?.address?.country === 'CA'
  const personalSignupUrl = currentUser?.email
    ? `${PERSONAL_SIGNUP_URL}?email=${encodeURIComponent(currentUser.email)}`
    : PERSONAL_SIGNUP_URL

  return (
    <div className="flex flex-col gap-6" data-testid="text-complete-container">
      <h1 className="text-2xl font-normal" data-testid="text-complete-heading">
        {t('registrationCompletePage.title')}
      </h1>

      <p className="text-base" data-testid="text-complete-message">
        {t('registrationCompletePage.message')}
      </p>

      <Button
        onClick={() => navigate(CORPORATE_UPLOAD_PATH)}
        className="inline-flex items-center py-8 px-4 w-full justify-center lg:gap-2"
        data-testid="btn-complete-upload-documents"
      >
        {t('registrationCompletePage.uploadButton')}
      </Button>

      <CorporateSupportLine />

      {canRegisterPersonally && (
        <>
          <p className="text-base" data-testid="text-complete-personal">
            {t('registrationCompletePage.personalPrompt')}
          </p>

          <Button
            onClick={() =>
              window.open(personalSignupUrl, '_blank', 'noopener,noreferrer')
            }
            className="inline-flex items-center py-8 px-4 w-full justify-center lg:gap-2"
            data-testid="btn-complete-personal-registration"
          >
            {t('registrationCompletePage.personalButton')}
          </Button>
        </>
      )}
    </div>
  )
}
